import { useEffect, useState } from "react";
import axios from "axios";
import { ExternalLink, Plus } from "lucide-react";
import { API } from "@/components/listings/common";
import { ListingTable } from "@/components/listings/ListingTable";
import { ListingEditor } from "@/components/listings/ListingEditor";
import { RequestsPanel } from "@/components/listings/RequestsPanel";

const TABS = [["listings", "İlanlar"], ["requests", "Talepler"]];

export default function ListingsAdmin() {
  const [tab, setTab] = useState("listings"), [meta, setMeta] = useState(null), [editing, setEditing] = useState(null);
  const loadMeta = () => axios.get(`${API}/listings/meta`).then((r) => setMeta(r.data)).catch(() => {});
  useEffect(() => { loadMeta(); }, []);
  if (editing) return <ListingEditor initial={editing.id ? editing : null} meta={meta} onClose={() => setEditing(null)} />;
  return (
    <>
      <div className="page-title"><div><span className="eyebrow">WEB SİTESİ · EMLAKSEPETI.ONLINE</span><h1 data-testid="page-title">İlanlar</h1><p>İlanları buradan ekleyin; yayına aldığınız ilanlar sitede görünür, isterseniz Instagram'da da paylaşılır.</p></div>
        <div className="lst-head-actions"><a className="outline-btn" href="/" target="_blank" rel="noreferrer" data-testid="listings-open-site"><ExternalLink size={15} />Siteyi aç</a><button className="primary-btn" onClick={() => setEditing({})} data-testid="listings-new-btn"><Plus size={16} />Yeni ilan</button></div></div>
      <div className="toolbar bulk-tabs">{TABS.map(([k, l]) => <button key={k} className={tab === k ? "filter-btn active" : "filter-btn"} onClick={() => setTab(k)} data-testid={`listings-tab-${k}`}>{l}{k === "requests" && meta?.new_requests > 0 && <em className="nav-badge" data-testid="listings-requests-badge">{meta.new_requests}</em>}</button>)}</div>
      {tab === "listings" && <ListingTable onEdit={setEditing} />}
      {tab === "requests" && <RequestsPanel onChanged={loadMeta} />}
    </>
  );
}
